import { Statistic } from "antd";
import axios from "axios";
import { useState } from "react";

// Payplus Production Config
//
const clientID = "6bdcf01e-ba18-4999-8af1-5a9665568a6f";
const scopes = "payplus.merchant payplus.merchant.write";
const baseURL = "https://endeavour.payplus.com.au";
const redirectURI = "https://prod-payplus-merchant-au.pages.dev/";

// Localhost Config
//Sandboc Config
// const clientID = "0fd26f21-a38d-4bfa-88e5-b5382e5dee8c";
// const scopes = "payplus.merchant payplus.merchant.write";
// const baseURL = "https://endeavour.payplus.co.nz";
// const baseURL = "https://endeavour.uat.pa-g.com";
// const baseURL = "http://localhost";
// const redirectURI = "http://localhost:3002/merchant/";
const xMerchant = localStorage.getItem("XMerchant") || null;

const numberFormat = (num) => {
  return parseFloat(num)
    .toFixed(2)
    .replace(/\d(?=(\d{3})+\.)/g, "$&,");
};

const ISO8601 = (time) => {
  if (time === null) {
    return;
  }
  if (/\d{10}/.test(time)) {
    time = time * 1000;
  }
  const date = new Date(time);
  const formatted = date.toLocaleString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });
  return formatted;
};

const DateTime = ({ value }) => {
  const date = new Date(value * 1000);
  const year = date.getFullYear();
  const month = ("0" + (date.getMonth() + 1)).slice(-2);
  const day = ("0" + date.getDate()).slice(-2);
  const hours = ("0" + date.getHours()).slice(-2);
  const minutes = ("0" + date.getMinutes()).slice(-2);
  const seconds = ("0" + date.getSeconds()).slice(-2);

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

const ColoredStatistic = ({ title, value, precision = 2, prefix, suffix, ...props }) => {
  let color = "#ea3943";
  if (parseFloat(value) > 0) {
    color = "darkgreen";
  }
  if (isNaN(value) || value === null || value === undefined) {
    return;
  }
  if (prefix && !prefix.includes("%")) {
    const temp = prefix;
    prefix = suffix;
    suffix = temp;
  }
  return (
    <Statistic
      title={title}
      value={value}
      prefix={prefix}
      suffix={suffix}
      precision={precision}
      style={{ textAlign: "right" }}
      valueStyle={{ color: color, textAlign: "right" }}
      {...props}
    />
  );
};

const token = localStorage.getItem("access_token");

const Curl = axios.create({
  timeout: 30000,
  baseURL: baseURL,

  headers: {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
    // Xmerchant: xMerchant,
  },
});

Curl.interceptors.request.use((config) => {
  return config;
});
Curl.interceptors.response.use(
  (response) => response.data,
  (error) => {
    console.log("errorPCF", error);
    if (error.response.status === 403 || error.response.status === 401) {
      localStorage.setItem("access_token", "");
      window.location.reload();
      // authorize();
    }
    return Promise.reject(error.res.data);
  }
);

function generateCodeVerifier() {
  let codeVerifier = "";
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  for (let i = 0; i < 128; i++) {
    const index = Math.floor(Math.random() * characters.length);
    codeVerifier += characters.charAt(index);
  }

  return codeVerifier;
}

function sha256(plain) {
  // returns promise ArrayBuffer
  const encoder = new TextEncoder();
  const data = encoder.encode(plain);
  return window.crypto.subtle.digest("SHA-256", data);
}

function base64urlencode(a) {
  var str = "";
  var bytes = new Uint8Array(a);
  var len = bytes.byteLength;
  for (var i = 0; i < len; i++) {
    str += String.fromCharCode(bytes[i]);
  }
  return btoa(str).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

async function generateCodeChallenge(v) {
  var hashed = await sha256(v);
  var base64encoded = base64urlencode(hashed);
  return base64encoded;
}

const authorize = async () => {
  const client_id = clientID;
  const origin = redirectURI;
  const scope = scopes;
  const state = Math.random().toString(36).slice(-10);
  const code_verifier = generateCodeVerifier();
  const code_challenge = await generateCodeChallenge(code_verifier);

  sessionStorage.setItem("code_verifier", code_verifier);
  sessionStorage.setItem("state", state);

  console.log("#authorize");
  window.location.href = `${baseURL}/oauth2.0/authorize?response_type=code&client_id=${client_id}&redirect_uri=${origin}&state=${state}&scope=${scope}&code_challenge=${code_challenge}&code_challenge_method=S256`;
};

const authCodeGrant = async () => {
  const URLParams = new URLSearchParams(window.location.search);
  const code = URLParams.get("code");
  if (!code) {
    return false;
  }
  const state = URLParams.get("state");
  if (state !== sessionStorage.getItem("state")) {
    return false;
  }
  const form = new FormData();
  form.append("grant_type", "authorization_code");
  form.append("client_id", clientID);
  form.append("scope", scopes);
  form.append("redirect_uri", `${redirectURI}`);
  form.append("code", code);
  form.append("code_verifier", sessionStorage.getItem("code_verifier"));

  const tmp = axios.create();
  return await tmp
    .post(
      `${baseURL}/oauth2.0/token`,
      {
        grant_type: "authorization_code",
        client_id: clientID,
        scope: scopes,
        redirect_uri: `${window.location.href.split("?")[0]}`,
        code: code,
        code_verifier: sessionStorage.getItem("code_verifier"),
      },
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    )
    .then((res) => {
      localStorage.setItem("access_token", res.data.payload.access_token);
      return true;
    })
    .catch((err) => err.response);
};

const authorization = {
  headers: {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  },
};
const FloatAdd = (arg1, arg2, decimal) => {
  let r1, r2, m;
  try {
    r1 = arg1.toString().split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2));
  const result = (FloatMul(arg1, m) + FloatMul(arg2, m)) / m;
  if (decimal === undefined) {
    return result;
  }
  return Number(result.toFixed(decimal));
};

const FloatSubtraction = (arg1, arg2, decimal) => {
  let r1, r2, m, n;
  try {
    r1 = arg1.toString().split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2));
  n = r1 >= r2 ? r1 : r2;
  const result = ((arg1 * m - arg2 * m) / m).toFixed(n);
  if (decimal === undefined) {
    return result;
  }
  return Number(result.toFixed(decimal));
};

const FloatMul = (arg1, arg2, decimal) => {
  let m = 0;
  let s1 = arg1.toString();
  let s2 = arg2.toString();
  try {
    m += s1.split(".")[1].length;
  } catch (e) {}
  try {
    m += s2.split(".")[1].length;
  } catch (e) {}

  const result = (Number(s1.replace(".", "")) * Number(s2.replace(".", ""))) / Math.pow(10, m);
  if (decimal === undefined) {
    return result;
  }
  return Number(result.toFixed(decimal));
};

const FloatDiv = (arg1, arg2, decimal) => {
  let t1 = 0,
    t2 = 0,
    r1,
    r2;
  try {
    t1 = arg1.toString().split(".")[1].length;
  } catch (e) {}
  try {
    t2 = arg2.toString().split(".")[1].length;
  } catch (e) {}

  r1 = Number(arg1.toString().replace(".", ""));
  r2 = Number(arg2.toString().replace(".", ""));

  const result = (r1 / r2) * Math.pow(10, t2 - t1);
  if (decimal === undefined) {
    return result;
  }
  return Number(result.toFixed(decimal));
};

export {
  numberFormat,
  DateTime,
  ISO8601,
  ColoredStatistic,
  baseURL,
  authorization,
  Curl,
  authorize,
  authCodeGrant,
  FloatAdd,
  FloatDiv,
  FloatMul,
  FloatSubtraction,
};
